import type {
  GetPaymentMessageData,
  GetPaymentMessageParams,
  GetPaymentStudentData,
  GetPaymentStudentParams,
  GetReceiptData,
  GetReceiptParams,
  Pageable,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'

import { adaptAcademyPayment, adaptPaymentMessage, adaptPaymentStudents } from './adapters'
import type { AcademyPayment, PaymentMessage, PaymentStudent } from './schemas'

// 2026-10-14 백엔드 develop(6a0f8e7bb) 의 payment/controller/PaymentController.kt 로 확인. 조회 월은 yyyy-MM 이다.

/** 로그인한 학원의 그 달 이용 요금 */
export const getAcademyPayment = async (
  yearMonth: GetReceiptParams['yearMonth'],
  meta?: RequestMeta,
): Promise<AcademyPayment> => {
  const body = await httpClient().get<GetReceiptData>('/payments/academies', {
    params: { yearMonth },
    meta,
  })
  return adaptAcademyPayment(body.data)
}

/** 그 달 학생별 채점 문항 수·활동일수 */
export const getPaymentStudents = async (
  yearMonth: GetPaymentStudentParams['yearMonth'],
  meta?: RequestMeta,
): Promise<PaymentStudent[]> => {
  const body = await httpClient().get<GetPaymentStudentData>('/payments/academies/students', {
    params: { yearMonth },
    meta,
  })
  return adaptPaymentStudents(body.data)
}

export type PaymentMessageParams = Omit<GetPaymentMessageParams, 'pageable'> & Pageable

/** 그 달 문자 요금 합계와 발송 기록 */
export const getPaymentMessage = async (
  params: PaymentMessageParams,
  meta?: RequestMeta,
): Promise<PaymentMessage> => {
  const body = await httpClient().get<GetPaymentMessageData>('/payments/academies/messages', {
    params,
    meta,
  })
  return adaptPaymentMessage(body.data)
}
